module.exports = __webpack_public_path__ + "img/right-icon.1f0ca331.svg";